import Indexnavbar2 from "components/Navbars/Indexnavbar2";
import React, {useState, useEffect  } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer2 from "components/Footers/Footer2";
import ecbanner7 from "assets/img/ecbanner7.svg";
import ecservices4 from "assets/img/ecservices4.webp";
import ecservices5 from "assets/img/ecservices5.webp";
import ecservices6 from "assets/img/ecservices6.webp";
import Indelegantcarve from "assets/img/Indelegantcarve.webp"
import mobiledesignelegantcarve from "assets/img/mobiledesignelegantcarve.webp";
import websitedesignelegantcarve from "assets/img/websitedesignelegantcarve.webp";
import dedicatedsupport from "assets/img/dedicatedsupport.webp";
import ourwebsite from "assets/img/ourwebsite.webp";
import timelydeliver from "assets/img/timelydeliver.webp";
import topquality from "assets/img/topquality.webp";
import SliderPage from "views/SliderPage";
import Profile from "views/Profile";
import GallerySlider1 from "views/GallerySlider1";
import webapp from "assets/img/webapp.png"
import mobileapp from "assets/img/mobileapp.png"
import webdesign from "assets/img/webdesign.png"
import branding from "assets/img/branding.png"
import vision from "assets/img/vision.webp"
import mision from "assets/img/mision.webp"
import value from "assets/img/value.webp"
import websitedesigninbangalore from "assets/img/websitedesigninbangalore.webp"
import webandmobileappdevelopment from "assets/img/webandmobileappdevelopment.webp"
import ecommercewebsitedesign from "assets/img/ecommercewebsitedesign.webp"
import watsapp from "assets/img/watsapp.webp";
import phones from "assets/img/phones.webp";
import nextjs from "assets/img/nextjs.webp";
import html from "assets/img/html.webp";
import css from "assets/img/css.webp";
import Drupal from "assets/img/Drupal.webp"
import mysql from "assets/img/mysql.webp";
import tailwind from "assets/img/tailwind.webp";
import sass from "assets/img/sass.webp";
import react from "assets/img/react.webp";
import php2 from "assets/img/php2.webp";
import codeigniter from "assets/img/codeigniter.webp";
import wordpress from "assets/img/wordpress.webp";
import shopify from "assets/img/shopify.webp";
import laravel from "assets/img/laravel.webp";
import Popup from './Popup';

export default function Homepage1() {


  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Set a timer to show the popup after 20 seconds
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 10000); // 30000ms = 20 seconds

    // Clean up the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <section>
      <Indexnavbar2 />

      <section className="xl:block lg:block md:block sm:hidden hidden bg-newshade4 roboto relative ">

        {/* <a href="https://wa.me/+919036323422" class="float" target="_blank">
          <i class="fab fa-whatsapp my-float"></i>
        </a> */}
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div className="container mx-auto xl:px-4 xl:pt-16 lg:px-4 lg:pt-12 md:px-4 md:pt-12">
          <div className="flex items-center justify-center">
            <div className="text-container">
              <h1 className="xl:text-6xl text-white text-center poppins font-weightt lg:text-4xl md:text-4xl">
                Building Digital
              </h1>
              <h1 className=" xl:text-6xl font-medium poppins xl:mt-2 lg:mt-2 md:mt-2 text-white text-center lg:text-4xl md:text-4xl">
                Product and Brands Experience
              </h1>
            </div>
          </div>

          <p className="xl:text-xl xl:px-52 poppins font-semibold text-white font-weightt text-center lg:text-lg md:text-lg xl:pt-4 md:pt-6 lg:pt-6">
            We believe that great design is the key to building a <br></br>strong
            connection with your audience
          </p>

          <div className="flex xl:pt-12 md:pt-6 lg:pt-6 mx-auto justify-center" >
            <div className="text-center align-center justify-center " style={{ textAlign: '-webkit-center' }}>
              <div className="justify-center" style={{ textAlign: '-webkit-center' }}>
                <img src={webapp} className="w-12" alt="Web-Design-Company-Bangalore"></img>
              </div>
              <h2 className="poppins xl:text-base text-white  xl:pt-2 font-medium">
                Web Applications
              </h2>
            </div>

            <div className="text-center align-center px-12">
              <div className="justify-center" style={{ textAlign: '-webkit-center' }}>
                <img src={webdesign} className="w-12" alt="Web-Development-Company-Bangalore"></img>
              </div>
              <h2 className="poppins xl:text-base text-white  xl:pt-2 font-medium">
                Web Design
              </h2>
            </div>

            <div className="text-center align-center">
              <div className="justify-center" style={{ textAlign: '-webkit-center' }}>
                <img src={mobileapp} className="w-12" alt="Website-Design-Company-Bangalore"></img>
              </div>
              <h2 className="poppins xl:text-base text-white  xl:pt-2 font-medium">
                Mobile Applications
              </h2>
            </div>

            <div className="text-center align-center px-12">
              <div className="justify-center" style={{ textAlign: '-webkit-center' }}>
                <img src={branding} className="w-12" alt="Website-Development-Company-Bangalore"></img>
              </div>
              <h2 className="poppins xl:text-base text-white  xl:pt-2 font-medium">
                Branding
              </h2>
            </div>
          </div>

          <div className="xl:mt-24 xl:pb-12 poppins lg:mt-12 md:mt-12 md:pb-12">
            {/* <h1 className="xl:text-lg font-semibold text-white lg:text-lg">
                Trusted by amazing clients and brands{" "}
              </h1> */}

            <div className="xl:mt-12 lg:mt-12">
              {/* <div className="">
                <Landing />
              </div> */}
            </div>
            <div className="xl:mt-8 lg:mt-8 md:mt-12">
              <div className="">
                <GallerySlider1 />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:block lg:block md:hidden sm:hidden hidden roboto xl:pb-12 lg:pb-12">
        {/* <div className="flex justify-end ">
          <img class="xl:w-32 xl:-mt-52 lg:w-20 lg:-mt-28" src={ecbanner7} />
        </div> */}

        <div className="container mx-auto  xl:mt-12 xl:pb-6 lg:pb-12  lg:mt-12">
          <div className="poppins grid grid-cols-2 xl:px-8 ">
            <div>
            <p className="poppins text-base text-grey-600 font-bold text-left">
                SERVICES
              </p>
              <h1 className="xl:text-5xl font-weightt text-black lg:text-4xl pt-2">
                What <span className="font-semibold">We Do</span>
              </h1>
            </div>
          </div>
          <div className=" xl:mt-12 grid grid-cols-3 xl:ml-6 lg:mt-8 xl:pb-12">
            <div>
              <div>
                <div
                  style={{
                    backgroundImage: `url(${ecservices4})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img
                        class="xl:w-48 lg:w-20 animate-up-down"
                        src={websitedesigninbangalore} alt="Best-website-design-company-Chennai"
                      />
                    </div>
                    <h1 className="poppins xl:text-3xl text-center text-darkblack xl:pt-8 font-semibold lg:text-2xl lg:pt-10">
                      Website / Landing<br></br>Page Design
                    </h1>
                  </div>
                </div>
                <p className=" xl:block lg:hidden md:hidden sm:hidden hidden poppins xl:text-sm text-black xl:pt-5 text-justify lg:text-sm lg:pt-5">
                  We create engaging and user-centric business <br></br>websites
                  stunning landing page for your business<br></br> like our
                  website.
                </p>
                <p className="xl:hidden lg:block md:hidden sm:hidden hidden poppins text-black   lg:text-sm lg:pt-5">
                  We create engaging and user-centric business websites stunning
                  landing page<br></br> for your business like our website.
                </p>
              </div>
            </div>

            <div className="">
              <div>
                <p className="xl:block lg:hidden md:hidden sm:hidden hidden poppins xl:text-sm  text-black text-justify ">
                  Convert your business app idea into a successful application
                  with our dedicated on-demand app development services.
                </p>
                <p className="xl:hidden lg:block md:hidden sm:hidden hidden poppins lg:text-sm  text-black text-justify ">
                  Convert your business app idea into a successful application
                  with our dedicated on-demand app development services.
                </p>
                <div
                  className="xl:mt-5 lg:mt-5"
                  style={{
                    backgroundImage: `url(${ecservices5})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundColor: "#040229",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img
                        class="xl:w-48 lg:w-20 animate-up-down"
                        src={webandmobileappdevelopment}
                        alt="Bangalore-website-design-company"
                      />
                    </div>
                    <h1 className="poppins xl:text-3xl text-center text-white xl:pt-8 font-semibold lg:text-2xl lg:pt-10">
                      Web / Mobile App<br></br> development
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <div>
                <div
                  style={{
                    backgroundImage: `url(${ecservices6})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img
                        class="xl:w-48 lg:w-20 animate-up-down"
                        src={ecommercewebsitedesign}
                        alt="Bangalore-web-design-company"
                      />
                    </div>
                    <h1 className="poppins xl:text-3xl text-center text-darkblack xl:pt-8 font-semibold lg:text-2xl lg:pt-10">
                      Woocommerce / <br></br> Shopify
                    </h1>
                  </div>
                </div>
                <p className="xl:block lg:hidden md:hidden sm:hidden hidden poppins xl:text-sm text-black xl:pt-5 text-justify">
                  Elevate and optimize your wooCommerce, shopify <br></br>stores
                  with our custom design innovations services.
                </p>
                <p className=" xl:hidden lg:block md:hidden sm:hidden hidden poppins lg:text-sm text-black lg:pt-5 text-justify">
                  Elevate and optimize your wooCommerce, shopify stores with our
                  custom design innovations services.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="flex justify-end">
          <img class="xl:w-32 lg:w-20" src={ecservices7} />
        </div> */}
        <div>
          <hr className="border-blue-50  container mx-auto xl:px-20 lg:px-20"></hr>
        </div>

        <div className=" xl:px-4 lg:px-8">
          <div className="container mx-auto poppins flex justify-between xl:mt-12 lg:mt-12">
            <p className="xl:text-base text-grey-600 font-bold lg:text-base">
              PORTFOLIO
            </p>
            {/* <div>
              <img class="xl:w-32 lg:w-20 " src={ecservices8} />
            </div> */}
          </div>
          <div className="container mx-auto xl:mt-2">
            <h1 className="poppins xl:text-5xl font-weightt text-darkblack lg:text-4xl">
            Experience <span className="font-semibold">Our Finest </span>Creations </h1>


          </div>

          <div className=" xl:mt-12 lg:mt-10 xl:pb-12">
            <div>
              <div>
                <SliderPage />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:block lg:block md:hidden sm:hidden hidden roboto bg-newshade4 xl:pb-16 lg:pb-16">
        <div className="container mx-auto xl:px-40">
          <div className="flex justify-between">
            <div className="">
              <img
                class="animate-up-down1 xl:w-24 xl:-mt-8 lg:w-20 lg:-mt-6"
                src={websitedesignelegantcarve}
                alt="Website-Design-Company-India"
              />
            </div>

            <div>
              <img
                class="animate-up-down1 xl:w-24 xl:-mt-8 lg:w-20 lg:-mt-6"
                src={mobiledesignelegantcarve}
                alt="Web-Design-company-India"
              />
            </div>
          </div>
        </div>

        <div className="container mx-auto xl:px-8 xl:mt-4 lg:px-8 lg:mt-4 ">
          <p className="poppins xl:text-base text-green1 font-bold text-center lg:text-base">
            WORKFLOW
          </p>
          <h1 className="poppins xl:text-5xl text-white font-weightt xl:pt-4 text-center lg:text-4xl">
          Get Started in Just
          </h1>
          <div className="flex justify-center pt-2">
            <h1 className="poppins xl:text-5xl text-yellow font-semibold lg:text-4xl ">
             4 Steps
            </h1>

          </div>

          <div className="grid grid-cols-3 xl:mt-12  xl:gap-8 lg:mt-10 lg:gap-2">
            <div>
              <div className="bg-newshade7 h-10 w-10 rounded-full ">
                <p className="text-darkblack text-center font-semibold pt-2">
                  1
                </p>
              </div>
              <div className="xl:block lg:hidden md:hidden sm:hidden hidden">
                <div className="poppins flex xl:mt-4 lg:mt-4 ">
                  <p className="xl:text-base font-semibold text-white">
                    Our Web Strategy:
                  </p>
                  <p className="xl:text-base text-bluee xl:ml-1 ">
                    {" "}
                    We begin by evaluating
                  </p>
                </div>
              </div>

              {/*landscape heading*/}
              <div className="xl:hidden lg:block md:hidden sm:hidden hidden">
                <div className="poppins flex  lg:mt-4 ">
                  <p className="text-base font-semibold text-white">
                    Our Web Strategy :
                  </p>
                  <p className="text-base text-bluee ml-1  "> We begin by</p>
                </div>
              </div>

              <p className="poppins xl:text-base text-bluee text-justify lg:text-base">
                your goals, user-focused design and SEO techniques to ensure we
                meet your business targets.
              </p>

              <div className="bg-newshade7 h-10 w-10 rounded-full xl:mt-24 lg:mt-20">
                <p className="text-darkblack text-center font-semibold pt-2">
                  3
                </p>
              </div>
              <div className="poppins flex xl:mt-4 lg:mt-4">
                <p className="xl:text-base font-semibold text-white lg:text-base">
                  Top Work Quality:{" "}
                </p>
                <p className="xl:text-base text-bluee ml-1 lg:text-base">
                  We stand by our
                </p>
              </div>
              <p className="poppins xl:text-base text-bluee text-justify lg:text-base">
                commitment to delivering high-quality results that align
                perfectly with your business needs.
              </p>
            </div>

            <div className="poppins xl:pt-24 xl:ml-12 lg:pt-24 lg:ml-8">
              <div>
                <img class="xl:w-9/12 xl:w-8/12" src={ourwebsite}  
                alt="e-commerce-website-design-company"/>
              </div>
              <div className="xl:mt-2 lg:mt-2">
                <img class="xl:w-9/12 lg:w-8/12" src={dedicatedsupport} 
                alt="shopify-store-creation-company-bangalore"/>
              </div>
              <div className="xl:mt-2 lg:mt-2">
                <img class="xl:w-9/12 lg:w-8/12" src={timelydeliver} 
                alt="shopify-website-design-company"/>
              </div>
              <div className="xl:mt-2 lg:mt-2">
                <img class="xl:w-9/12 lg:w-8/12" src={topquality} 
                alt="Website-Design-Company-Bangalore"/>
              </div>
            </div>

            <div className="xl:ml-12 lg:ml-2">
              <div className="bg-newshade7 h-10 w-10 rounded-full">
                <p className="text-darkblack text-center font-semibold pt-2">
                  2
                </p>
              </div>
              <div className="poppins flex xl:mt-4 lg:mt-4">
                <p className="xl:text-base font-semibold text-white lg:text-bas2">
                  Timely Delivery:
                </p>
                <p className="xl:text-base text-bluee ml-1 lg:text-base">
                  {" "}
                  we respect your time
                </p>
              </div>
              <p className="poppins xl:text-base text-bluee text-justify lg:text-base">
                and the importance of deadlines and work diligently to deliver
                projects on time.
              </p>

              <div className="bg-newshade7 h-10 w-10 rounded-full xl:mt-24 lg:mt-20">
                <p className="text-darkblack text-center font-semibold pt-2">
                  4
                </p>
              </div>
              <div className="poppins flex xl:mt-4 lg:mt-4">
                <p className="xl:text-base font-semibold text-white lg:text-base">
                  Dedicated Support:{" "}
                </p>
                <p className="xl:text-base text-bluee ml-1 lg:text-base">
                  our dedicated
                </p>
              </div>
              <p className="poppins xl:text-base text-bluee text-justify lg:text-base">
                support team ensures you receive outstanding service and
                immediate resolution of any concerns.
              </p>
            </div>
          </div>



          <div className="xl:mt-20 flex items-center lg:mt-20">
            <div className="xl:w-5/12 mr-2 lg:w-5/12">
              <hr className="border-blue-50"></hr>
            </div>
            <div className="flex justify-center">
              <div>
                <a href="/">
                  <button className="poppins bg-newshade8 xl:px-6 xl:py-3 rounded-full text-darkblack xl:text-lg font-semibold lg:px-6 lg:py-2 lg:text-sm">
                    Enquiry Us ↗
                  </button>
                </a>
              </div>
            </div>
            <div className="xl:w-5/12 ml-2 lg:w-5/12">
              <hr className="border-blue-50"></hr>
            </div>
          </div>
          </div>
      </section>



          {/* LOGO SLIDER */}
          <section className="bg-newshade4 xl:block lg:block hidden md:hidden">
            <div className="">
          <h4 className="text-white pt-4 text-center poppins xl:text-5xl">
            Technology <span className="font-semibold">We Use</span>
          </h4>
          <h2 className="md:mt-10">
          <logo-slider >
            <div className="px-2 ">
              <div className="bg-white shadow rounded  px-2">
                <div className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        ReactJS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        React as a frontend JavaScript framework, is a JavaScript library created by Facebook.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={react}
                        alt="Website-Design-Company-Bangalore"
                      />
                    </h1>
                  </h1>
                </div>
              </div>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Laravel
                      </h2>
                      <p className="head1 text-sm pt-2 font-normal">
                        Laravel is a powerful MVC web application framework with expressive, elegant syntax.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={laravel}
                        alt="Affordable web design companies in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

          

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold head1 text-xl text-black">
                        CodeIgniter
                      </h2>
                      <p className="head1 text-sm pt-2 cardcolor font-normal">
                        Application Development Framework a toolkit for people who build web sites using PHP.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={codeigniter}
                        alt="Top IT consultancy in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        PHP
                      </h2>
                      <p className="head1 text-sm pt-2">
                        PHP is a server scripting language, a powerful tool for making dynamic and interactive Web pages.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={php2}
                        alt="Software company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        WordPress
                      </h2>
                      <p className="head1 text-sm pt-2">
                        WordPress is a content management system (CMS) that allows you to host and build websites.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={wordpress}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Shopify
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Shopify is a comprehensive e-commerce platform that allows you to create, customize online stores.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={shopify}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Laravel
                      </h2>
                      <p className="head1 text-sm pt-2 font-normal">
                        Laravel is a powerful MVC web application framework with expressive, elegant syntax.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={laravel}
                        alt="Affordable web design companies in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            


            <div className="px-2 ">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        ReactJS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        React as a frontend JavaScript framework, is a JavaScript library created by Facebook.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={react}
                        alt="Elegant carve IT solutions"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>


          </logo-slider>
        </h2>

        <h2 className="pb-16">
          <logo-slider2>
          <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Next Js
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Next.js is a React-based framework that enables server-side rendering and static site generation for fast applications.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={nextjs}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        HTML
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Standard markup language for creating Web pages and tell the browser to display the content.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={html}
                        alt="Top SEO providers in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Drupal
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Drupal is a free and open-source web content management system written in PHP and distributed under the GNU
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={Drupal}
                        alt="Top web design and digital marketing company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        CSS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        CSS describes how HTML elements are to be displayed on screen, paper, or in other media.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={css}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold head1 text-xl text-black">
                        Mysql
                      </h2>
                      <p className="head1 text-sm pt-2 cardcolor font-normal">
                        MySQL is an open-source relational database management system based on structured query language.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={mysql}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Sass
                      </h2>
                      <p className="head1 text-sm pt-2">
                        The most mature, stable, powerful professional grade CSS extension language in the world.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6 w-full"
                        src={sass}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Tailwind Css
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Tailwind CSS is basically a utility-first CSS framework for rapidly building custom user interfaces.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={tailwind}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>


            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Next Js
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Next.js is a React-based framework that enables server-side rendering and static site generation for fast applications.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={nextjs}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full lg:w-12/12 md:w-12/12 ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="lg:w-8/12 md:w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        HTML
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Standard markup language for creating Web pages and tell the browser to display the content.
                      </p>
                    </h1>
                    <h1 className="lg:w-3/12 md:w-3/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={html}
                        alt="Top SEO providers in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            
          </logo-slider2>
        </h2>

        </div>
      </section>

      <div className="container mx-auto xl:mt-2 lg:mt-12 xl:py-12 xl:block lg:block md:hidden hidden">
        <div className="poppins">
          <p className="xl:text-5xl xl:pt-2 text-center text-black font-weightt lg:text-4xl lg:pt-2">
            What
            <span className="xl:text-5xl text-center text-black font-bold xl:ml-2 xl:mt-2 lg:text-4xl lg:ml-2 lg:mt-2">
              Defines Us{" "}
            </span>
          </p>
        </div>
        <p className="poppins xl:text-lg xl:pt-2 text-center text-black xl:px-52 font-normal lg:text-lg lg:pt-2">
          We are dedicated to transforming your bold vision into a
          remarkable success story, reaching across borders and time.
        </p>

        <div className="grid grid-cols-3 gap-8 xl:mt-12 lg:mt-10">
          <div className="">
            <div className=" rounded-md  xl:p-6 lg:p-8">
              <div className="flex justify-center">
                <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                  <img class="p-2 justify-center" src={vision} 
                  alt="Bangalore-website-design-company"/>
                </div>
              </div>
              <div className="poppins flex justify-center xl:mt-4 lg:mt-4">
                <h1 className="xl:text-xl text-black font-semibold uppercase lg:text-xl">
                  Vision
                </h1>
              </div>
              <p className="poppins xl:text-base text-black xl:pt-4 text-center lg:text-base">
                Our vision is to position and consolidate our company as a
                leading supplier of Software Engineering products and
                services.
              </p>
            </div>
          </div>

          <div className="">
            <div className="border-l border-r  border-grey-100 xl:p-6 lg:p-8">
              <div className="flex justify-center">
                <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                  <img class="p-2 justify-center" src={mision} 
                  alt="website-design-bangalore"/>
                </div>
              </div>
              <div className="poppins flex justify-center xl:mt-4 lg:mt-4">
                <h1 className="xl:text-xl text-black font-semibold uppercase lg:text-xl">
                  Mission
                </h1>
              </div>
              <p className="poppins xl:text-base  text-black xl:pt-4 text-center lg:text-base lg:pt-4">
                We develop and apply technologically innovating solutions to
                satisfy the customer's needs, goals and profitable
                situation.
              </p>
            </div>
          </div>

          <div className="">
            <div className=" xl:p-6 lg:p-8">
              <div className="flex justify-center">
                <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                  <img class="p-2 justify-center" src={value} 
                  alt="shopify-website-design-company"/>
                </div>
              </div>
              <div className="flex justify-center xl:mt-4 lg:mt-4">
                <h1 className="poppins xl:text-xl text-black font-semibold uppercase lg:text-xl">
                  Value
                </h1>
              </div>
              <p className="xl:text-base poppins text-black xl:pt-4 text-center text-justify lg:text-base">
                our company actions on the Honesty and Respect, Quality,
                Efficiency, Innovation and Investigation, Team work,
                Commitment.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>


      <section className="bg-newshade4 xl:block lg:block md:hidden hidden sm:hidden">
        <div className="container mx-auto xl:pt-2">
          <div className="xl:mt-20 lg:mt-8">
            <p className="poppins text-darkblue xl:text-base font-bold text-center lg:text-base">
              TESTIMONIAL
            </p>
            <div className="poppins flex justify-center xl:mt-10 lg:mt-4">
              <h1 className="xl:text-5xl font-weightt text-white lg:text-4xl">
                Words from our
              </h1>
              <h1 className="xl:text-5xl font-semibold text-yellow ml-2 lg:text-4xl">
                Clients
              </h1>
            </div>

            <div className="xl:mt-12 lg:mt-8">
              <div className="">
                <Profile />
              </div>
            </div>


          </div>
        </div>
      </section>

      {/*tabview*/}

      <section className="xl:hidden lg:hidden md:block sm:hidden hidden poppins pb-12">
        {/* <div className="flex justify-end ">
          <img class="w-24 -mt-24" src={ecbanner7} />
        </div> */}

        <div className="container mx-auto px-8 mt-24 pb-12">
          <div className="poppins grid grid-cols-2 ">
            <div>
            <p className="poppins text-lg text-grey-600 font-bold ">
                SERVICES
              </p>
              <h1 className="text-4xl font-bold text-darkblack ">What We Do</h1>
            </div>
            {/* <div>
              <p className="poppins text-lg text-grey-600 font-bold  ml-52">
                SERVICES
              </p>
            </div> */}
          </div>
          <div className=" mt-8 grid grid-cols-3 ">
            <div>
              <div>
                <div
                  style={{
                    backgroundImage: `url(${ecservices4})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img class="w-20 animate-up-down" src={websitedesigninbangalore} 
                      alt="Best-website-design-company-Chennai"/>
                    </div>
                    <h1 className="poppins text-xl text-center text-darkblack pt-12 font-bold ">
                      Website / Landing<br></br>Page Design
                    </h1>
                  </div>
                </div>
                <p className="  poppins text-sm text-black pt-5 text-justify">
                  We create engaging and user-centric business websites stunning
                  landing page for your business like our website.
                </p>
              </div>
            </div>

            <div className="">
              <div>
                <p className="poppins text-sm  text-black text-justify ">
                  Convert your business app idea into a successful application
                  with our dedicated on-demand app development services.
                </p>
                <div
                  className="mt-5 "
                  style={{
                    backgroundImage: `url(${ecservices5})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundColor: "#040229",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img class="w-20 animate-up-down" src={webandmobileappdevelopment} 
                      alt="Bangalore-website-design-company"/>
                    </div>
                    <h1 className="poppins text-xl text-center text-white pt-12 font-semibold ">
                      Web / Mobile App<br></br> development
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <div>
                <div
                  style={{
                    backgroundImage: `url(${ecservices6})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img class="w-20  animate-up-down" src={ecommercewebsitedesign} 
                      alt="Bangalore-web-design-company"/>
                    </div>
                    <h1 className="poppins text-xl text-center text-darkblack pt-12 font-semibold ">
                      Woocommerce / <br></br> Shopify
                    </h1>
                  </div>
                </div>

                <p className="  poppins text-sm text-black pt-5 text-justify">
                  Elevate and optimize your wooCommerce, shopify stores with our
                  custom design innovations services.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="flex justify-end">
          <img class="w-20" src={ecservices7} />
        </div> */}
        <div>
          <hr className="border-blue-50  container mx-auto px-20 "></hr>
        </div>

        <div className="container mx-auto px-8">
          <div className="poppins flex justify-between mt-12 ">
            <p className="text-base text-grey-600 font-bold ">PORTFOLIO</p>
            {/* <div>
              <img class="w-20 " src={ecservices8} />
            </div> */}
          </div>
          <div className="flex xl:mt-12">
            <h1 className="poppins text-4xl font-semibold text-darkblack ">
            Experience <span className="font-semibold">Our Finest</span> Creations 
            </h1>
          </div>
          

          <div className="mt-10">
            <div>
              <div>
                <SliderPage />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:hidden lg:hidden md:block sm:hidden hidden poppins bg-newshade4 pb-12">
        <div className="container mx-auto px-20">
          <div className="flex justify-between">
            <div className="">
              <img class="animate-up-down1 w-12 -mt-8" src={websitedesignelegantcarve} 
              alt="Website-Design-Company-India"/>
            </div>

            <div>
              <img class="animate-up-down1 w-12 -mt-8" src={mobiledesignelegantcarve} 
              alt="Web-Design-company-India"/>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-8 mt-4  ">
          <p className="poppins text-base text-green1 font-bold text-center ">
            WORKFLOW
          </p>
          <h1 className="poppins text-4xl text-white font-bold pt-3 text-center ">
          Get Started in Just
          </h1>
          <div className="flex justify-center ">
            <h1 className="poppins text-4xl text-yellow font-semibold  ">
             4 Steps
            </h1>
          </div>

          <div className="grid grid-cols-3 mt-10 ">
            <div>
              <div className="bg-newshade7 h-10 w-10 rounded-full ">
                <p className="text-darkblack text-center font-semibold pt-2">
                  1
                </p>
              </div>
              <div className="">
                <div className="poppins flex mt-4  ">
                  <p className="text-sm font-semibold text-white">
                    Our Web Strategy:
                  </p>
                  <p className="text-sm text-bluee ml-1 "> We begin by</p>
                </div>
              </div>

              <p className="poppins text-sm text-bluee text-justify ">
                evaluating your goals, user-focused design and SEO techniques to
                ensure we meet your business targets.
              </p>

              <div className="bg-newshade7 h-10 w-10 rounded-full mt-20">
                <p className="text-darkblack text-center font-semibold pt-2">
                  3
                </p>
              </div>
              <div className="poppins flex mt-4">
                <p className="text-sm font-semibold text-white lg:text-base">
                  Top Work Quality:{" "}
                </p>
                <p className="text-sm text-bluee ml-1 ">We stand by</p>
              </div>
              <p className="poppins text-sm text-bluee text-justify ">
                our commitment to delivering high-quality results that align
                perfectly with your business needs.
              </p>
            </div>

            <div className="poppins pt-32 ml-2">
              <div>
                <img class="w-10/12" src={dedicatedsupport}
                alt="shopify-store-creation-company-bangalore" />
              </div>
              <div className="mt-2">
                <img class="w-10/12" src={ourwebsite} 
                alt="e-commerce-website-design-company"/>
              </div>
              <div className="mt-2">
                <img class="w-10/12" src={timelydeliver} 
                alt="shopify-website-design-company"/>
              </div>
              <div className="mt-2">
                <img class="w-10/12" src={topquality} 
                alt="Website-Design-Company-Bangalore"/>
              </div>
            </div>

            <div className="ml-2">
              <div className="bg-newshade7 h-10 w-10 rounded-full">
                <p className="text-darkblack text-center font-semibold pt-2">
                  2
                </p>
              </div>
              <div className="poppins flex mt-4">
                <p className="text-sm font-semibold text-white ">
                  Timely Delivery:
                </p>
                <p className="text-sm text-bluee ml-1 "> we respect</p>
              </div>
              <p className="poppins text-sm text-bluee text-justify ">
                your time and the importance of deadlines and work diligently to
                deliver projects on time.
              </p>

              <div className="bg-newshade7 h-10 w-10 rounded-full mt-20">
                <p className="text-darkblack text-center font-semibold pt-2">
                  4
                </p>
              </div>
              <div className="poppins flex mt-4">
                <p className="text-sm font-semibold text-white ">
                  Dedicated Support:{" "}
                </p>
                <p className="text-sm text-bluee ml-1 ">our</p>
              </div>
              <p className="poppins text-sm text-bluee text-justify ">
                dedicated support team ensures you receive outstanding service
                and immediate resolution of any concerns.
              </p>
            </div>
          </div>

          <div className="mt-12 flex items-center ">
            <div className="w-6/12 mr-2">
              <hr className="border-blue-50"></hr>
            </div>
            <div className="flex justify-center">
              <div>
                <a href="/">
                  <button className="poppins bg-newshade8 px-8 py-2 rounded-full text-darkblack text-xs font-semibold ">
                    EnquiryUs↗
                  </button>
                </a>
              </div>
            </div>
            <div className="w-6/12 ml-2 ">
              <hr className="border-blue-50"></hr>
            </div>
          </div>
        </div>


        {/* LOGO SLIDER */}
      <h4 className="text-white mt-12 text-center poppins md:text-4xl font-semibold">
            Technology We Use
          </h4>
          <h2 className="md:mt-10">
          <logo-slider >
            <div className="px-2 ">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        ReactJS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        React as a frontend JavaScript framework, is a JavaScript library created by Facebook.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={react}
                        alt="Elegant carve IT solutions"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Laravel
                      </h2>
                      <p className="head1 text-sm pt-2 font-normal">
                        Laravel is a powerful MVC web application framework with expressive, elegant syntax.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={laravel}
                        alt="Affordable web design companies in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

          

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold head1 text-xl text-black">
                        CodeIgniter
                      </h2>
                      <p className="head1 text-sm pt-2 cardcolor font-normal">
                        Application Development Framework a toolkit for people who build web sites using PHP.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={codeigniter}
                        alt="Top IT consultancy in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        PHP
                      </h2>
                      <p className="head1 text-sm pt-2">
                        PHP is a server scripting language, a powerful tool for making dynamic and interactive Web pages.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={php2}
                        alt="Software company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        WordPress
                      </h2>
                      <p className="head1 text-sm pt-2">
                        WordPress is a content management system (CMS) that allows you to host and build websites.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={wordpress}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Shopify
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Shopify is a comprehensive e-commerce platform that allows you to create, customize online stores.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={shopify}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
          </logo-slider>
        </h2>

        <h2 className="pb-16">
          <logo-slider2>
          <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Next Js
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Next.js is a React-based framework that enables server-side rendering and static site generation for fast applications.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={nextjs}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        HTML
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Standard markup language for creating Web pages and tell the browser to display the content.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={html}
                        alt="Top SEO providers in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Drupal
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Drupal is a free and open-source web content management system written in PHP and distributed under the GNU
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={Drupal}
                        alt="Top web design and digital marketing company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        CSS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        CSS describes how HTML elements are to be displayed on screen, paper, or in other media.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={css}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold head1 text-xl text-black">
                        Mysql
                      </h2>
                      <p className="head1 text-sm pt-2 cardcolor font-normal">
                        MySQL is an open-source relational database management system based on structured query language.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={mysql}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Sass
                      </h2>
                      <p className="head1 text-sm pt-2">
                        The most mature, stable, powerful professional grade CSS extension language in the world.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6 w-full"
                        src={sass}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Tailwind Css
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Tailwind CSS is basically a utility-first CSS framework for rapidly building custom user interfaces.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={tailwind}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
          </logo-slider2>
        </h2>
        
      </section>


      




      <section className="bg-white xl:hidden lg:hidden md:block hidden">
        <div className="container mx-auto py-12">
          <div className="mt-12">
            <div className="poppins">
              <p className="text-center text-black font-weightt text-4xl pt-2">
                What
                <span className=" text-center text-black font-bold ml-2 mt-2 text-4xl ">
                  Defines Us{" "}
                </span>
              </p>
            </div>
            <p className="poppins text-lg pt-2 text-center text-black px-20 font-normal">
              We are dedicated to transforming your bold vision into a
              remarkable success story, reaching across borders and time.
            </p>

            <div className="grid grid-cols-3 mt-10">
              <div className="">
                <div className=" rounded-md p-6">
                  <div className="flex justify-center">
                    <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                      <img class="p-4 justify-center" src={vision} 
                      alt="Bangalore-website-design-company"/>
                    </div>
                  </div>
                  <div className="poppins flex justify-center mt-4">
                    <h1 className="text-xl text-black font-semibold uppercase ">
                      Vision
                    </h1>
                  </div>
                  <p className="poppins text-base text-black pt-4 text-center ">
                    Our vision is to position and consolidate our company as a
                    leading supplier of Software Engineering products and
                    services.
                  </p>
                </div>
              </div>

              <div className="">
                <div className="border-l border-r p-6">
                  <div className="flex justify-center">
                    <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                      <img class="p-4 justify-center" src={mision} 
                      alt="website-design-bangalore"/>
                    </div>
                  </div>
                  <div className="poppins flex justify-center mt-4">
                    <h1 className="text-xl text-black font-semibold uppercase ">
                      Mission
                    </h1>
                  </div>
                  <p className="poppins text-base  text-black pt-4 text-center ">
                    We develop and apply technologically innovating solutions to
                    satisfy the customer's needs, goals and profitable
                    situation.
                  </p>
                </div>
              </div>

              <div className="">
                <div className=" p-6">
                  <div className="flex justify-center">
                    <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                      <img class="p-4 justify-center" src={value} 
                      alt="shopify-website-design-company"/>
                    </div>
                  </div>
                  <div className="flex justify-center mt-4 ">
                    <h1 className="poppins text-xl text-black font-semibold uppercase ">
                      Value
                    </h1>
                  </div>
                  <p className="text-base poppins text-black pt-4 text-center text-justify ">
                    our company actions on the Honesty and Respect, Quality,
                    Efficiency, Innovation and Investigation, Team work,
                    Commitment.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="bg-newshade4 mt-12  xl:hidden lg:hidden md:block hidden">
        <div className="container mx-auto ">
          <div className="py-16">
            <p className="poppins text-darkblue text-base font-bold text-center">
              TESTIMONIAL
            </p>
            <div className="poppins flex justify-center mt-4">
              <h1 className="text-4xl font-weeightt text-white ">
                Words from our
              </h1>
              <h1 className="font-semibold text-yellow ml-2 text-4xl">
                Clients
              </h1>
            </div>

            <div className="mt-8">
              <div className="">
                <Profile />
              </div>
            </div>

            {/* <div className="poppins mt-12">
              <h1 className="text-lg font-semibold text-white ">
                Trusted by amazing clients and brands{" "}
              </h1>

              <div className="mt-12">
                <div className="">
                  <Landing />
                </div>
              </div>
              <div className="mt-8">
                <div className="">
                  <GallerySlider1 />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>







      {/*mobileview*/}

      <section className="xl:hidden lg:hidden md:hidden sm:block block bg-newshade4 poppins pb-12">
        <div className="container mx-auto px-4">
          <div className="text-container pt-6 ">
            <h1 className="text-3xl text-weightt text-white text-center poppins">
              Building Digital
            </h1>
            <h1 className=" text-2xl font-semibold text-white text-center pt-1 ">
              Product and Brands Experience
            </h1>
          </div>
          <div className=" content-item poppins mt-4">
            <p className="text-sm font-semibold text-bluee content-item text-center">
              We believe that great design is the key to building a strong
              connection with your audience
            </p>
          </div>
          <div className="mt-12">
            <div className="">
              <GallerySlider1 />
            </div>
          </div>
        </div>
      </section>

      <section className="xl:hidden lg:hidden md:hidden sm:block block poppins pb-12">
        {/* <div className="flex justify-end ">
          <img class="w-12 -mt-12" src={ecbanner7} />
        </div> */}

        <div className="container mx-auto px-8 mt-12 pb-12">
          <div className="poppins  ">
            <div>
              <p className="poppins text-lg text-grey-600 font-bold text-center">
                SERVICES
              </p>
              <h1 className="text-3xl font-bold text-darkblack text-center">
                What We Do
              </h1>
            </div>
            <div></div>
          </div>
          <div className=" mt-8  ">
            <div>
              <div>
                <div
                  style={{
                    backgroundImage: `url(${ecservices4})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img class="w-20 animate-up-down" src={websitedesigninbangalore} 
                      alt="Best-website-design-company-Chennai"/>
                    </div>
                    <h1 className="poppins text-xl text-center text-darkblack pt-12 font-bold ">
                      Website / Landing<br></br>Page Design
                    </h1>
                  </div>
                </div>
                <p className="  poppins text-sm text-black pt-2 text-center">
                  We create engaging and user-centric business websites stunning
                  landing page for your business like our website.
                </p>
              </div>
            </div>

            <div className="mt-8">
              <div>
                <div
                  className="mt-5 "
                  style={{
                    backgroundImage: `url(${ecservices5})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundColor: "#040229",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img class="w-20 animate-up-down" src={webandmobileappdevelopment} 
                      alt="Bangalore-website-design-company"/>
                    </div>
                    <h1 className="poppins text-xl text-center text-white pt-12 font-semibold ">
                      Web / Mobile App<br></br> development
                    </h1>
                  </div>
                </div>
              </div>
              <p className="poppins text-sm  text-black text-center pt-2">
                Convert your business app idea into a successful application
                with our dedicated on-demand app development services.
              </p>
            </div>

            <div className="mt-8">
              <div>
                <div
                  style={{
                    backgroundImage: `url(${ecservices6})`,
                    width: "95%",
                    height: "250px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                >
                  <div>
                    <div className="flex justify-center center-content">
                      <img class="w-20  animate-up-down" src={ecommercewebsitedesign} 
                      alt="Bangalore-web-design-company"/>
                    </div>
                    <h1 className="poppins text-xl text-center text-darkblack pt-12 font-semibold ">
                      Woocommerce / <br></br> Shopify
                    </h1>
                  </div>
                </div>

                <p className="  poppins text-sm text-black pt-2 text-center">
                  Elevate and optimize your wooCommerce, shopify stores with our
                  custom design innovations services.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="flex justify-end">
          <img class="w-20" src={ecservices7} />
        </div> */}
        <div>
          <hr className="border-blue-50  container mx-auto px-20 "></hr>
        </div>

        <div className="container mx-auto px-8">
          <div className="poppins flex justify-between mt-12 ">
            <p className="text-base text-grey-600 font-bold ">PORTFOLIO</p>
            {/* <div>
              <img class="w-20 " src={ecservices8} />
            </div> */}
          </div>
          <div className="">
            <h1 className="poppins text-3xl  text-darkblack ">
            Experience <span className="font-semibold">Our Finest </span>Creations 
            </h1>
          </div>

          <div className="mt-10">
            <div>
              <div>
                <SliderPage />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* mobile view */}

      <section className="xl:hidden lg:hidden md:hidden sm:block block poppins bg-newshade4 pb-12">
        <div className="container mx-auto px-8">
          <div className="flex justify-between">
            <div className="">
              <img class="animate-up-down1 w-12 -mt-8" src={websitedesignelegantcarve} 
              alt="Website-Design-Company-India"/>
            </div>

            <div>
              <img class="animate-up-down1 w-12 -mt-8" src={mobiledesignelegantcarve} 
              alt="Web-Design-company-India"/>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4">
          <p className="poppins text-base text-green1 font-bold text-center  pt-12">
            WORKFLOW
          </p>
          <h1 className="poppins text-3xl text-white font-bold pt-3 text-center ">
          Get Started in Just
          </h1>
          <div className="flex justify-center ">
            <h1 className="poppins text-3xl text-yellow font-semibold  ">
              4 Steps
            </h1>
          </div>

          <div className="poppins mt-8 center">
            <div>
              <img class="w-8/12" src={dedicatedsupport} 
              alt="shopify-store-creation-company-bangalore"/>
            </div>
            <div className="mt-2">
              <img class="w-8/12" src={ourwebsite} 
              alt="e-commerce-website-design-company"/>
            </div>
            <div className="mt-2">
              <img class="w-8/12" src={timelydeliver} 
              alt="shopify-website-design-company"/>
            </div>
            <div className="mt-2">
              <img class="w-8/12" src={topquality} 
              alt="Website-Design-Company-Bangalore"/>
            </div>
          </div>

          <div className="mt-8">
            <div className="bg-newshade7 h-10 w-10 rounded-full ">
              <p className="text-darkblack text-center font-semibold pt-2">1</p>
            </div>
            <div className="">
              <div className="poppins flex mt-4  ">
                <p className="text-sm font-semibold text-white">
                  Our Web Strategy :
                </p>
                <p className="text-sm text-bluee ml-1 "> We begin by</p>
              </div>
            </div>

            <p className="poppins text-sm text-bluee text-justify ">
              evaluating your goals, user-focused design and SEO techniques to
              ensure we meet your business targets.
            </p>

            <div className="bg-newshade7 h-10 w-10 rounded-full mt-4">
              <p className="text-darkblack text-center font-semibold pt-2">2</p>
            </div>
            <div className="poppins flex mt-4">
              <p className="text-sm font-semibold text-white lg:text-base">
                Top Work Quality :{" "}
              </p>
              <p className="text-sm text-bluee ml-1 ">We stand by</p>
            </div>
            <p className="poppins text-sm text-bluee text-justify ">
              our commitment to delivering high-quality results that align
              perfectly with your business needs.
            </p>
          </div>
          <div className="mt-4">
            <div className="bg-newshade7 h-10 w-10 rounded-full">
              <p className="text-darkblack text-center font-semibold pt-2">3</p>
            </div>
            <div className="poppins flex mt-4">
              <p className="text-sm font-semibold text-white ">
                Timely Delivery :
              </p>
              <p className="text-sm text-bluee ml-1 "> we respect</p>
            </div>
            <p className="poppins text-sm text-bluee text-justify ">
              your time and the importance of deadlines and work diligently to
              deliver projects on time.
            </p>

            <div className="bg-newshade7 h-10 w-10 rounded-full mt-4">
              <p className="text-darkblack text-center font-semibold pt-2">4</p>
            </div>
            <div className="poppins flex mt-4">
              <p className="text-sm font-semibold text-white ">
                Dedicated Support :{" "}
              </p>
              <p className="text-sm text-bluee ml-1 ">our</p>
            </div>
            <p className="poppins text-sm text-bluee text-justify ">
              dedicated support team ensures you receive outstanding service and
              immediate resolution of any concerns.
            </p>
          </div>
          <div className="flex justify-center mt-8">
            <a href="/">
              <button className="poppins bg-newshade8 px-8 py-2 rounded-full text-darkblack text-xs font-semibold ">
                EnquiryUs↗
              </button>
            </a>
          </div>
        </div>



        {/* LOGO SLIDER */}
        <h4 className="text-white mt-12 text-center poppins text-3xl font-semibold">
            Technology We Use
          </h4>
          <h2 className="mt-10 ">
          <logo-slider3 >
            <div className="px-2 ">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        ReactJS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        React as a frontend JavaScript framework, is a JavaScript library created by Facebook.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={react}
                        alt="Elegant carve IT solutions"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Laravel
                      </h2>
                      <p className="head1 text-sm pt-2 font-normal">
                        Laravel is a powerful MVC web application framework with expressive, elegant syntax.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={laravel}
                        alt="Affordable web design companies in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

          

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold head1 text-xl text-black">
                        CodeIgniter
                      </h2>
                      <p className="head1 text-sm pt-2 cardcolor font-normal">
                        Application Development Framework a toolkit for people who build web sites using PHP.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={codeigniter}
                        alt="Top IT consultancy in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        PHP
                      </h2>
                      <p className="head1 text-sm pt-2">
                        PHP is a server scripting language, a powerful tool for making dynamic and interactive Web pages.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={php2}
                        alt="Software company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        WordPress
                      </h2>
                      <p className="head1 text-sm pt-2">
                        WordPress is a content management system (CMS) that allows you to host and build websites.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={wordpress}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Shopify
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Shopify is a comprehensive e-commerce platform that allows you to create, customize online stores.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={shopify}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Laravel
                      </h2>
                      <p className="head1 text-sm pt-2 font-normal">
                        Laravel is a powerful MVC web application framework with expressive, elegant syntax.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={laravel}
                        alt="Affordable web design companies in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
          </logo-slider3>
        </h2>

        <h2 className="pb-16">
          <logo-slider4>
          <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Next Js
                      </h2>
                      <p className="head1 text-sm pt-2">
                      Next.js is a React-based framework that enables server-side rendering and static site generation for fast applications.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={nextjs}
                        alt="App Devlopment Company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        HTML
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Standard markup language for creating Web pages and tell the browser to display the content.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={html}
                        alt="Top SEO providers in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full  ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Drupal
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Drupal is a free and open-source web content management system written in PHP and distributed under the GNU
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={Drupal}
                        alt="Top web design and digital marketing company in Bangalore"
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        CSS
                      </h2>
                      <p className="head1 text-sm pt-2">
                        CSS describes how HTML elements are to be displayed on screen, paper, or in other media.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={css}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold head1 text-xl text-black">
                        Mysql
                      </h2>
                      <p className="head1 text-sm pt-2 cardcolor font-normal">
                        MySQL is an open-source relational database management system based on structured query language.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={mysql}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Sass
                      </h2>
                      <p className="head1 text-sm pt-2">
                        The most mature, stable, powerful professional grade CSS extension language in the world.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6 w-full"
                        src={sass}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>

            <div className="px-2">
              <h1 className="bg-white shadow rounded  px-2">
                <h1 className="w-full ">
                  <h1 className="flex flex-wrap p-4">
                    <h1 className="w-8/12 ">
                      <h2 className="font-bold text-xl text-black">
                        Tailwind Css
                      </h2>
                      <p className="head1 text-sm pt-2">
                        Tailwind CSS is basically a utility-first CSS framework for rapidly building custom user interfaces.
                      </p>
                    </h1>
                    <h1 className="w-2/12 px-2 textalignend">
                      <img
                        className="pt-6"
                        src={tailwind}
                        alt="..."
                      />
                    </h1>
                  </h1>
                </h1>
              </h1>
            </div>
          </logo-slider4>
        </h2>
      </section>


      {/* mobile view */}
      <section className="bg-white xl:hidden lg:hidden md:hidden">
        <div className="container mx-auto">
          <div className="mt-12">
            <div className="poppins">
              <p className="text-center text-black font-weightt text-3xl pt-2">
                What
                <span className=" text-center text-black font-bold ml-2 mt-2 text-3xl ">
                  Defines Us{" "}
                </span>
              </p>
            </div>
            <p className="poppins text-base pt-2 text-center text-black font-normal">
              We are dedicated to transforming your bold vision into a
              remarkable success story, reaching across borders and time.
            </p>

            <div className=" mt-10">
              <div className="">
                <div className=" rounded-md p-6">
                  <div className="flex justify-center">
                    <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                      <img class="p-4 justify-center" src={vision} alt="Bangalore-website-design-company"/>
                    </div>
                  </div>
                  <div className="poppins flex justify-center mt-4">
                    <h1 className="text-xl text-black font-semibold uppercase ">
                      Vision
                    </h1>
                  </div>
                  <p className="poppins text-base text-black pt-4 text-center ">
                    Our vision is to position and consolidate our company as a
                    leading supplier of Software Engineering products and
                    services.
                  </p>
                </div>
              </div>

              <div className="mt-2">
                <div className=" p-6">
                  <div className="flex justify-center">
                    <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                      <img class="p-4 justify-center" src={mision} 
                      alt="website-design-bangalore"/>
                    </div>
                  </div>
                  <div className="poppins flex justify-center mt-4">
                    <h1 className="text-xl text-black font-semibold uppercase ">
                      Mission
                    </h1>
                  </div>
                  <p className="poppins text-base  text-black pt-4 text-center ">
                    We develop and apply technologically innovating solutions to
                    satisfy the customer's needs, goals and profitable
                    situation.
                  </p>
                </div>
              </div>

              <div className="mt-2">
                <div className=" p-6">
                  <div className="flex justify-center">
                    <div className="border-box rounded-full w-16 h-16 justify-center flex ">
                      <img class="p-4 justify-center" src={value} 
                      alt="shopify-website-design-company"/>
                    </div>
                  </div>
                  <div className="flex justify-center mt-4 ">
                    <h1 className="poppins text-xl text-black font-semibold uppercase ">
                      Value
                    </h1>
                  </div>
                  <p className="text-base poppins text-black pt-4 text-center text-justify ">
                    our company actions on the Honesty and Respect, Quality,
                    Efficiency, Innovation and Investigation, Team work,
                    Commitment.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* mobile view */}

      <section className="bg-newshade4 mt-12 xl:hidden lg:hidden md:hidden block">
        <div className="container mx-auto">
          <div className="pt-12 pb-16">
            <p className="poppins text-darkblue text-base font-bold text-center">
              TESTIMONIAL
            </p>
            <div className="poppins  mt-4">
              <h1 className="text-3xl font-weightt text-white text-center">
                Words from <span className="pl-1 text-3xl font-semibold text-white text-center">
                  Our Clients </span>
              </h1>

            </div>

            <div className="mt-8 mx-1">
              <div className="">
                <Profile />
              </div>
            </div>

            {/* <div className="poppins mt-12">
              <h1 className="text-lg font-semibold text-white ">
                Trusted by amazing clients and brands{" "}
              </h1>

              <div className="mt-12">
                <div className="">
                  <Landing />
                </div>
              </div>
              <div className="mt-8">
                <div className="">
                  <GallerySlider1 />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/*endd*/}
      <section class="animate-up-down2 xl:block lg:block md:block hidden fixed right-0 bottom-0 mb-4 mr-4 rounded xl:p-6 p-4" style={{background: '#e0e0e0eb'}}>
        <a href="tel:+919036323422">
          <div class="bg-newshade5 rounded-md xl:px-4 xl:py-2 flex py-2 px-4 mt-4   xl:mt-4 cursor-pointer ">
            <img class="w-5 pt-1" src={phones} alt="Elegantcarve" />
            <p class="text-white xl:text-base ml-2 poppins font-medium">+91 9036323422</p>
          </div>
        </a>

        <a href="https://wa.me/+919036323422">
          <div style={{background: '#00d757'}} class=" rounded-md xl:px-4  xl:py-2  py-2 px-4 mt-4 flex  items-center xl:mt-4 cursor-pointer ">
          <img class="w-5 pt-1" src={watsapp} alt="Elegantcarve" />
            <p class="text-white xl:text-base poppins ml-2  font-medium">WhatsApp</p>
          </div>
        </a>
      </section>


      <section class="xl:hidden lg:hidden md:hidden block fixed right-0 bottom-0 mb-4 mr-4 rounded xl:p-6 " >
        <a href="tel:+919036323422">
          <div class="bg-newshade5  rounded-full  mt-4 flex  items-center xl:mt-4 cursor-pointer ">
            <img class="w-16 p-4" src={phones} alt="Elegantcarve" />
            {/* <p class="text-white xl:text-base ml-2 poppins font-medium">+91 9036323422</p> */}
          </div>
        </a>

        <a href="https://wa.me/+919036323422">
          <div style={{background: '#00d757'}} class=" rounded-full  mt-4 flex  items-center xl:mt-4 cursor-pointer ">
          <img class="w-16 p-4" src={watsapp} alt="Elegantcarve" />
            {/* <p class="text-white xl:text-base poppins ml-2  font-medium">WhatsApp</p> */}
          </div>
        </a>
      </section>


      <div>
    
      {showPopup && (
        <Popup 
          imageUrl={Indelegantcarve} // Replace with your image URL
          closePopup={closePopup}
        />
      )}
    </div>


      <Footer2 />
    </section>
  );
}
